import {
    KEYSFOBS_CREATE_EDIT_OPEN_MODAL,
    KEYSFOBS_GET_KEYFOB_REQUEST,
    KEYSFOBS_GET_KEYFOB_RESULT,
    KEYSFOBS_CREATE_REQUEST,
    KEYSFOBS_CREATE_RESULT,
    KEYSFOBS_UPDATE_REQUEST,
    KEYSFOBS_UPDATE_RESULT,
    KEYSFOBS_GET_DRIVER_REQUEST,
    KEYSFOBS_GET_DRIVER_RESULT,
} from 'Redux/actionTypes';

export const keyfobsGetDriversRequest = (data) => ({
    type: KEYSFOBS_GET_DRIVER_REQUEST,
    payload: data
})

export const keyfobsGetDriversResult = (result) => ({
    type: KEYSFOBS_GET_DRIVER_RESULT,
    payload: result
})



export const keyfobsCreateEditOpenModal = (id) => ({
    type: KEYSFOBS_CREATE_EDIT_OPEN_MODAL,
    payload: id
})

export const keyfobsCreateRequest = (data) => ({
    type: KEYSFOBS_CREATE_REQUEST,
    payload: data
})

export const keyfobsCreateResult = (result) => ({
    type: KEYSFOBS_CREATE_RESULT,
    payload: result
})

export const keyfobsUpdateRequest = (data) => ({
    type: KEYSFOBS_UPDATE_REQUEST,
    payload: data
})

export const keyfobsUpdateResult = (data) => ({
    type: KEYSFOBS_UPDATE_RESULT,
    payload: data
})

export const keyfobsGetKeyFobRequest = (data) => ({
    type: KEYSFOBS_GET_KEYFOB_REQUEST,
    payload: data
})

export const keyfobsGetKeyFobResult = (data) => ({
    type: KEYSFOBS_GET_KEYFOB_RESULT,
    payload: data
})